import React, { Component } from "react";
import { Link, Redirect, withRouter } from "react-router-dom"
import Axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import AppUrl from "../AppUrl/ApiUrl";
import jwt_decode from "jwt-decode";

class Login extends Component {
    constructor() {
        super();
        this.state = {
            password: "",email:"",loading:false
        }
    }

    componentDidMount(){
        var token = localStorage.getItem("admintoken");
        if(token){
          this.props.history.push("/")
        }
    }

    onpassword = (e) => {
        var password = e.target.value
        this.setState({ password: password })
    }
    email = (e) => {
        var email = e.target.value
        this.setState({ email: email })
    }

    onSuccess=(val)=>{
        toast.success(val, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
    onError=(val)=>{
        toast.error(val, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    formSubmit = (event) => {
        const formData = new FormData();
        formData.append("email", this.state.email);
        formData.append("password", this.state.password);
           if(this.state.password!=="" && this.state.email!==""){
                this.setState({loading:true})
                Axios.post(AppUrl.baseurl+"login", formData)
                .then(res => {
                    this.setState({loading:false})
                  if (res.data.success) {
                      this.onSuccess(res.data.success)
                } else {
                      this.onError(res.data.error)
                }
                    //console.log(res.data)
                    var token = res.data.token
                    var decoded = jwt_decode(token);
                    var type = decoded.usertype
                    if(type=="Admin" ){
                        console.log("okkk")
                      localStorage.setItem("admintoken",res.data.token)
                      setTimeout(
                          () => {
                              this.props.history.push("/")
                          }, 1000
                      )

                    }else{
                      this.onError("you are not authorized as admin")
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.setState({loading:false})
                })
            }


        event.preventDefault()
    }

    render() {
        return (
            <>
                <title>Account Login</title>
                <div className="container">
                <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-4 login ">

                            <h3 className="crp ">Login to your admin account<br /></h3>
                            <form onSubmit={this.formSubmit}>

                                <input onChange={this.email} className={" form-control form-control-lg shadow-none mb-2 "} type="email"
                                       placeholder="Email" aria-label="" />

                                <input onChange={this.onpassword} className={" form-control form-control-lg shadow-none mb-2 "} type="password"
                                    placeholder="Password" aria-label="" />
                               <br />
                                <div className="row">
                                    <div className="col-md-12">
                                        <button type="submit" disabled={this.state.loading}
                                                className="btn btn-primary shadow-none loginb ">
                                            {this.state.loading==true?"Loading...":"Log In"}
                                        </button>
                                    </div>
                                </div>
                            </form>

                        </div>
                        <div className="col-md-4"></div>
                    </div>
                </div>
            </>
        );
    }
}


export default withRouter(Login);